<!-- 角色管理 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    @click="goModal"
                    >新增角色</Button
                >
                <Table
                    ref="selection"
                    :columns="columnsTable"
                    :data="dataTable"
                    border
                    @on-selection-change="changeSelection"
                >
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sb">
                            <Button type="primary" ghost @click="goModal(row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(1, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox
                        class="checkbox-ml"
                        v-model="del_value"
                        @on-change="handleSelectAll"
                        >全选</Checkbox
                    >
                    <span class="mr24 ml24"
                        >已经选择{{ delData.length }}个</span
                    >
                    <Button type="error" ghost @click="goDel(0)">删除</Button>
                </div>
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 新增角色 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="700"
            :mask-closable="false"
        >
            <div>
                <Form
                    ref="formData"
                    :model="formData"
                    :rules="ruleValidate"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="角色名称：" prop="title">
                        <Input
                            class="w80"
                            type="text"
                            v-model="formData.title"
                            placeholder="请输入角色名称"
                        ></Input>
                    </FormItem>
                    <FormItem label="菜单权限：" prop="pc_rules">
                        <div class="tree-div">
                            <div>
                                <div>PC端权限</div>
                                <Tree
                                    :data="treeData1"
                                    show-checkbox
                                    multiple
                                    expand-node
                                    @on-check-change="changeTree($event, 1)"
                                ></Tree>
                            </div>
                            <div class="tree-border"></div>
                            <div>
                                <div>H5权限</div>
                                <Tree
                                    :data="treeData2"
                                    show-checkbox
                                    multiple
                                    expand-node
                                    @on-check-change="changeTree($event, 2)"
                                ></Tree>
                            </div>
                        </div>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelForm">取消</Button>
                <Button
                    class="theme-bc ml24 theme-default-color"
                    @click="submitForm"
                    >确定</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    account_roles_list,
    account_roles_create,
    account_roles_info,
    account_roles_menus,
    account_roles_delete,
} from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: "selection", width: 50, align: "center" },
                { type: "index", width: 60, align: "center" },
                { title: "角色名称", key: "title", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            modals: false,
            modalTitle: "",
            formData: {
                id: "",
                title: "",
                pc_rules: [],
                h5_rules: [],
                pc_unchosen_rules: [],
                h5_unchosen_rules: [],
            },
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            ruleValidate: {
                title: [
                    {
                        required: true,
                        message: "请输入角色名称",
                        trigger: "blur",
                    },
                ],
                rules: [
                    {
                        required: true,
                        message: "请选择菜单权限",
                        trigger: "blur",
                    },
                ],
            },
            pcData: [],
            h5Data: [],
            treeData1: [],
            treeData2: [],
        };
    },
    mounted() {
        this.getList();
        this.getAccountRolesMenus();
    },
    methods: {
        getList() {
            account_roles_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        // 角色详情
        getAccountRolesInfo() {
            account_roles_info({ id: this.formData.id })
                .then((res) => {
                    this.formData.pc_rules = res.data.pc_rules;
                    this.formData.h5_rules = res.data.h5_rules;
                    this.formData.pc_unchosen_rules =
                        res.data.pc_unchosen_rules;
                    this.formData.h5_unchosen_rules =
                        res.data.h5_unchosen_rules;
                    this.changeData();
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        inArray(arr, value) {
            return !arr.includes(value);
        },
        // 选中导航时处理逻辑
        changeTree(event, i) {
            this.$forceUpdate();
            let data = event;
            if (i == 1) {
                // pc
                this.formData.pc_rules = [];
                data.forEach((item) => {
                    this.formData.pc_rules.push(item.id);
                });
                this.formData.pc_unchosen_rules = [];
                data.forEach((item) => {
                    if (
                        item.pid != 0 &&
                        this.inArray(
                            this.formData.pc_unchosen_rules,
                            item.pid
                        ) &&
                        this.inArray(this.formData.pc_rules, item.pid)
                    ) {
                        this.formData.pc_unchosen_rules.push(item.pid);
                    }
                });
            } else if (i == 2) {
                //h5
                this.formData.h5_rules = [];
                data.forEach((item) => {
                    this.formData.h5_rules.push(item.id);
                });
                this.formData.h5_unchosen_rules = [];
                data.forEach((item) => {
                    if (
                        item.pid != 0 &&
                        this.inArray(
                            this.formData.h5_unchosen_rules,
                            item.pid
                        ) &&
                        this.inArray(this.formData.h5_rules, item.pid)
                    ) {
                        this.formData.h5_unchosen_rules.push(item.pid);
                    }
                });
            }
        },
        // 所有菜单
        getAccountRolesMenus() {
            account_roles_menus()
                .then((res) => {
                    this.pcData = res.data.pc;
                    this.h5Data = res.data.h5;
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 处理菜单导航是否选中状态
        changeData() {
            let data1 = this.pcData;
            data1.forEach((item) => {
                if (this.formData.pc_rules.indexOf(item.id + "") !== -1) {
                    item.checked = true;
                } else {
                    item.checked = false;
                }
                if (item.children) {
                    item.expand = false;
                    item.children.forEach((itm) => {
                        if (
                            this.formData.pc_rules.indexOf(itm.id + "") !== -1
                        ) {
                            itm.checked = true;
                        } else {
                            itm.checked = false;
                        }
                    });
                }
            });
            this.treeData1 = JSON.parse(JSON.stringify(data1));
            
            let data2 = this.h5Data;
            data2.forEach((item) => {
                if (this.formData.h5_rules.indexOf(item.id + "") !== -1) {
                    item.checked = true;
                } else {
                    item.checked = false;
                }
                if (item.children) {
                    item.expand = false;
                    item.children.forEach((itm) => {
                        if (
                            this.formData.h5_rules.indexOf(itm.id + "") !== -1
                        ) {
                            itm.checked = true;
                        } else {
                            itm.checked = false;
                        }
                    });
                }
            });
            this.treeData2 = JSON.parse(JSON.stringify(data2));
        },
        // Modal
        goModal(row) {
            if (row.id) {
                this.modalTitle = "编辑角色";
                this.formData.id = row.id;
                this.formData.title = row.title;
                this.getAccountRolesInfo();
            } else {
                this.modalTitle = "新增角色";
                this.formData.id = "";
                this.formData.title = "";
                this.formData.pc_rules = [];
                this.formData.h5_rules = [];
                this.formData.pc_unchosen_rules = [];
                this.formData.h5_unchosen_rules = [];
                this.changeData();
            }
            setTimeout(() => {
                this.modals = true;
            }, 300);
        },
        cancelForm() {
            this.modals = false;
        },
        // 确定（提交表单）
        submitForm() {
            account_roles_create(this.formData)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // selection
        changeSelection(e) {
            this.delData = e;
            if (this.dataTable.length === e.length) {
                this.del_value = true;
            } else {
                this.del_value = false;
            }
        },
        handleSelectAll(e) {
            if (e == true) {
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            } else {
                this.$refs.selection.selectAll(false);
            }
        },
        goDel(index, row) {
            if (index == 0 && this.delData.length == 0) {
                this.$Message.error("请选择");
                return;
            }
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 0) {
                        var del_id = [];
                        this.delData.forEach((item) => {
                            del_id.push(item.id);
                        });
                        this.del_id = del_id.join(",");
                        account_roles_delete({ ids: this.del_id })
                            .then((res) => {
                                this.getList();
                                this.del_value = false;
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    } else if (index == 1) {
                        account_roles_delete({ ids: row.id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
    },
};
</script>
<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.footer {
    position: absolute;
    right: 20px;
    bottom: 20px;
}
.w80 {
    width: 80%;
}
.tree-div {
    width: 80%;
    display: flex;
    justify-content: space-between;
}
.tree-border {
    margin: auto 0;
    width: 1px;
    height: 100px;
    background-color: #cccccc;
    height: 20vh;
}
.checkbox-ml {
    margin-left: 20px !important;
}
::v-deep .ivu-tree ul li {
    margin: 0;
    padding: 0;
    list-style: none;
    white-space: nowrap;
    outline: 0;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53c41a;
    border-color: #53c41a;
    box-shadow: -1px 0 0 0 #53c41a;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
::v-deep .ivu-checkbox {
    margin-right: 12px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: var(--primary-color);
    background-color: var(--primary-color);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>
